(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    var gallery = document.currentScript && document.currentScript.closest('.product-gallery');
    if (!gallery) {
      // fallback: first gallery on page
      gallery = document.querySelector('.product-gallery');
    }
    if (!gallery) return;

    var featured = gallery.querySelector('.product-gallery__featured');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumb'));
    if (!featured) return;

    var pendingIndex = null;
    var currentPreload = null;

    // Preload all gallery images on initialization
    (function preloadAllImages() {
      thumbs.forEach(function (thumb) {
        var large = thumb.getAttribute('data-large-src');
        var srcset = thumb.getAttribute('data-srcset');
        if (large) {
          var img = new Image();
          img.src = large;
          if (srcset) img.srcset = srcset;
        }
      });
    })();

    // Ensure the correct thumbnail is highlighted on load
    (function initActiveThumb() {
      var initial = String(featured.getAttribute('data-media-index') || '0');
      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      var activeThumb = gallery.querySelector('.product-gallery__thumb[data-media-index="' + initial + '"]');
      if (activeThumb) activeThumb.classList.add('is-active');
    })();

    function setActive(index) {
      index = String(index);
      var thumb = gallery.querySelector('.product-gallery__thumb[data-media-index="' + index + '"]');
      if (!thumb) return;
      var large = thumb.getAttribute('data-large-src');
      var srcset = thumb.getAttribute('data-srcset');

      // mark this index as the most recent request
      pendingIndex = index;

      featured.style.transition = 'opacity 140ms ease';
      featured.style.opacity = '0';

      // cancel previous preload handler so its onload won't apply
      if (currentPreload && typeof currentPreload.onload === 'function') {
        currentPreload.onload = null;
      }

      var preload = new Image();
      currentPreload = preload;
      if (srcset) preload.srcset = srcset;
      if (large) preload.src = large;

      preload.onload = function () {
        // ignore stale loads triggered by previous requests
        if (pendingIndex !== index) return;
        if (large) featured.src = large;
        if (srcset) featured.srcset = srcset;
        featured.setAttribute('data-media-index', index);
        featured.style.opacity = '1';
        currentPreload = null;
        pendingIndex = null;
      };

      // Fallback: if preload doesn't load within 800ms, swap anyway
      setTimeout(function () {
        if (pendingIndex === index) {
          if (large) featured.src = large;
          if (srcset) featured.srcset = srcset;
          featured.setAttribute('data-media-index', index);
          featured.style.opacity = '1';
          currentPreload = null;
          pendingIndex = null;
        }
      }, 800);

      thumbs.forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
    }

    thumbs.forEach(function (button) {
      button.addEventListener('click', function (e) {
        var idx = this.getAttribute('data-media-index');
        setActive(idx);
      });
    });

    // keyboard navigation when gallery is focused
    gallery.addEventListener('keydown', function (e) {
      var current = parseInt(featured.getAttribute('data-media-index') || 0, 10);
      if (e.key === 'ArrowRight') {
        setActive(Math.min(current + 1, thumbs.length - 1));
      } else if (e.key === 'ArrowLeft') {
        setActive(Math.max(current - 1, 0));
      }
    });

    // touch swipe support on featured image
    (function () {
      var startX = 0;
      var threshold = 30;
      featured.addEventListener(
        'touchstart',
        function (ev) {
          startX = ev.touches[0].clientX;
        },
        { passive: true }
      );
      featured.addEventListener(
        'touchend',
        function (ev) {
          var endX = ev.changedTouches[0].clientX;
          var dx = endX - startX;
          var current = parseInt(featured.getAttribute('data-media-index') || 0, 10);
          if (dx < -threshold) {
            setActive(Math.min(current + 1, thumbs.length - 1));
          } else if (dx > threshold) {
            setActive(Math.max(current - 1, 0));
          }
        },
        { passive: true }
      );
    })();
  })();
  } catch(e) { console.error(e); }
})();

})();
